import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '@stores/authStore';

interface PublicLayoutProps {
  children: ReactNode;
}

export default function PublicLayout({ children }: PublicLayoutProps) {
  const { user } = useAuthStore();

  return (
    <div className="min-h-screen bg-white">
      {/* Top Navigation Bar */}
      <header className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          {/* Logo and Home */}
          <div className="flex items-center gap-8">
            <Link to="/" className="flex items-center gap-3">
              <div className="w-8 h-8 bg-[#1F55A6] rounded-lg flex items-center justify-center">
                <img 
                  src="/assets/images/logos/logo-icon-white.svg" 
                  alt="Z-Tools" 
                  className="w-6 h-[18px]"
                />
              </div>
              <img 
                src="/assets/images/logos/logo-zasya-text.svg" 
                alt="Zasya" 
                className="h-8"
              />
            </Link>
            <nav className="flex items-center gap-6">
              <Link 
                to="/" 
                className="text-gray-600 hover:text-[#1F55A6] font-['Poppins'] font-medium text-base transition-colors"
              >
                Home
              </Link>
              <Link 
                to="/tools" 
                className="text-[#1F55A6] font-['Poppins'] font-medium text-base"
              >
                Browse Apps
              </Link>
            </nav>
          </div>

          {/* Right side */}
          <div className="flex items-center gap-6">
            {user ? (
              <>
                <span className="text-gray-600 font-['Poppins'] text-sm">
                  Welcome, {user.firstName}
                </span>
                <div className="w-px h-6 bg-gray-300" />
                <Link 
                  to="/dashboard"
                  className="text-gray-600 hover:text-[#1F55A6] font-['Poppins'] font-medium text-sm transition-colors"
                >
                  Dashboard
                </Link>
              </>
            ) : (
              <>
                <Link 
                  to="/login" 
                  className="text-gray-600 hover:text-[#1F55A6] font-['Poppins'] font-medium text-sm transition-colors"
                >
                  Login
                </Link>
                <Link 
                  to="/signup" 
                  className="bg-[#1F55A6] text-white px-4 py-2 rounded-lg font-['Poppins'] font-medium text-sm hover:bg-[#1a4a91] transition-colors"
                >
                  Sign Up
                </Link>
              </>
            )}
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto">
        {children}
      </main>

      {/* Simple Footer */}
      <footer className="bg-gray-50 border-t border-gray-200 mt-12">
        <div className="max-w-7xl mx-auto px-6 py-8">
          <div className="text-center text-gray-600 font-['Poppins'] text-sm">
            <p>&copy; 2024 Zasya Online. All rights reserved.</p>
            <div className="flex justify-center gap-6 mt-4">
              <Link to="/privacy" className="hover:text-[#1F55A6] transition-colors">Privacy</Link>
              <Link to="/terms" className="hover:text-[#1F55A6] transition-colors">Terms</Link>
              <Link to="/contact" className="hover:text-[#1F55A6] transition-colors">Contact</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
